import { DataRequest } from 'shared/data/datarequest';

import { LookupItem } from 'runtime/data/lookupitem';

export class LookupItemUpdate extends DataRequest {
    static $type = 'Web.LookupItemUpdate';

    identifier: string;
    fieldName: string;
    lookupItem: LookupItem;
}